export default "__VITE_ASSET__BXwzsdBT__"